<template>
  <div>
    <div class="content">
      <div class="contentTop">
        <div class="contentTopTitle">销售订单列表</div>
        <div class="contentTopRight">
          <div class="yida" @click="yida" v-premiSub="'销售订单_宜搭导入'">
            <img src="@/assets/images/production/dingding.png" alt="">
            <span>钉钉导入</span>
          </div>
          <div class="update" v-premiSub="'更新装配和生产工单'" @click="updateFn">更新工单</div>
          <el-tooltip v-premiSub="'销售订单_拆分'" class="item" effect="dark" content="拆分" placement="top">
            <img src="@/assets/images/production/split.png" alt="" @click="split">
          </el-tooltip>
          <el-tooltip v-premiSub="'销售订单_合并'" class="item" effect="dark" content="合并" placement="top">
            <img src="@/assets/images/production/merge.png" alt="" @click="merge">
          </el-tooltip>
          <el-tooltip class="item" effect="dark" v-premiSub="'销售订单_导入'" content="导入" placement="top">
            <img src="@/assets/images/production/leading-in.png" @click="importVisible = true" alt="">
          </el-tooltip>
          <el-tooltip v-premiSub="'销售订单_导出'" class="item" effect="dark" content="导出" placement="top">
            <img src="@/assets/images/production/export.png" @click="exportFn" alt="">
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="刷新" placement="top">
            <img src="@/assets/images/production/renovate.png" alt="" @click="renovate">
          </el-tooltip>
          <el-input placeholder="请输入关键词" suffix-icon="el-icon-search" size="small" v-model="input2"
            @change="searchHandler">
          </el-input>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tempData" tooltip-effect="dark" style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="65">
        </el-table-column>
        <el-table-column prop="showId" label="序号" fixed="left" width="80">
        </el-table-column>
        <el-table-column prop="orderStatus" label="工单状态" width="120">
          <template slot="header" slot-scope={}>
            <el-dropdown trigger="click" size="medium" class="OrderStatus" @command="handleCommand">
              <span style="color:#909399">
                工单状态<i class="el-icon-arrow-down el-icon--right" />
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in section" :key="index" :command="item">
                  {{ item }}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
          <template slot-scope="scope">
            <span
              :class="{ 'cell_Green': (scope.row.orderStatus == 1), 'cell_Yellow': (scope.row.orderStatus == 2) }"></span>
            <span style="margin-left: 10px" v-if="(scope.row.orderStatus == 1)">正式</span>
            <span style="margin-left: 10px" v-if="(scope.row.orderStatus == 2)">意向</span>
          </template>
        </el-table-column>
        <el-table-column prop="priority" label="优先级" width="100">
        </el-table-column>
        <el-table-column prop="orderNo" label="订单号" width="150">
        </el-table-column>
        <el-table-column prop="customerName" label="客户" width="130">
        </el-table-column>
        <el-table-column prop="materialNo" label="物料编码" width="150">
        </el-table-column>
        <el-table-column prop="productName" label="产品名称" width="150">
        </el-table-column>
        <el-table-column prop="partCode" label="图号" width="150">
        </el-table-column>
        <el-table-column prop="versionCode" label="版本号" width="150">
        </el-table-column>
        <el-table-column prop="rawMaterial" label="材质" width="120">
        </el-table-column>
        <el-table-column prop="plannedQuantity" label="订单数量" width="150">
        </el-table-column>
        <el-table-column prop="orderCompletionDateStr" label="订单需求日期" width="150">
        </el-table-column>
        <el-table-column prop="materialProperty" label="物料属性" width="150">
        </el-table-column>
        <el-table-column prop="isSplitBom" label="是否拆分BOM单" width="150">
        </el-table-column>
        <el-table-column prop="planStartTime" label="计划开始时间" width="200" label-class-name="GreenColor">
        </el-table-column>
        <el-table-column prop="planCompletionTime" label="计划完成时间" width="200" label-class-name="GreenColor">
        </el-table-column>
        <el-table-column prop="varianceDay" label="差异天数" width="200" label-class-name="GreenColor">
          <template slot-scope="scope">
            <div
              :class="{ bgColorGreen: (scope.row.overdueStatus === 1), bgColorRed: (scope.row.overdueStatus === 2) }">
              {{
                scope.row.varianceDay
              }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="totalFlex">
        <span>共{{ total }}条</span>
        <span>
          <el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
            :current-page="currentPage1" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size=pageChange
            layout="prev, pager, next,sizes, jumper" :total=total>
          </el-pagination> </span>
      </div>
    </div>
    <resultDialog :name="name" :fileName="fileName" :resultMsg="resultMsg" :resultVisible="resultVisible"
      @reUpload="reUpload" :type="type" @update:resultVisible="closeFn" />
    <merge :isShow="isShow" :title="mergeTitle" @closeMerge="closeMerge" :mergeData="mergeData" @OKMerge="OKMerge"
      :mark="mark" />
    <split :isShowSplit="isShowSplit" :title="splitTitle" @closeSplit="closeSplit" :splitData="splitData" :mark="mark"
      @splitOk="splitOk" />
    <ImportDialog v-if="importVisible" :visible.sync="importVisible" templateName="销售订单导入模板" templateParam="saleOrder"
      :apis="apis" @success="handleProduction('update')" />
    <updateWarning :saleDialog="saleDialog" @saleHandleClose="saleHandleClose" @checkReason="checkReason" />
  </div>
</template>

<script>
const resultDialog = () => import("@/components/upload/resultDialog.vue")
const merge = () => import("@/components/merge.vue")
const split = () => import("@/components/split.vue")
const updateWarning = () => import("@/components/updateWarning.vue")
import ImportDialog from '@/components/dialog/ImportDialog.vue'
import { getSaleData, importSale, searchSaleData, importOrder2, export2, updateOrder, updateReason } from '@/api/orders.js'
import { getDay } from "@/utils/date.js"
export default {
  name: "sale",
  components: {
    resultDialog, merge, split, ImportDialog, updateWarning
  },
  data() {
    return {
      saleDialog: false,
      apis: {
        import: importSale,//导入请求的接口
        // importTemplate:excelTemplate,//下载模板接口
      },
      name: '',
      fileName: '',
      resultVisible: false,
      resultMsg: '',
      type: true,
      status: false,
      tableData: [],
      total: 0, //总条数，用于分组组件
      currentPage1: 1,
      input2: '',
      tempData: [],
      tempData2: [],  //筛选后的数据
      section: [
        '正式',
        '意向'
      ],
      limitNum: 1, //文件上传个数限制
      fileList: [], //文件列表
      pageChange: 10,   //当前页面多少条订单
      tempTotal: 0, //总条数，但与分页组件无关
      searchStatus: false,
      searchData: [],
      multipleSelection: [],
      isShowSplit: false,
      isShow: false,
      mergeTitle: '合并',
      splitTitle: '拆分',
      mergeData: [],
      splitData: [],
      importVisible: false,
      mark: 2
    }
  },
  methods: {
    saleHandleClose() {
      this.saleDialog = false
    },
    async checkReason() {
      const res = await updateReason()
      this.filename = `订单未更新成功原因 ${getDay()}.xlsx`
      this.url = window.URL.createObjectURL(res)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.url
      link.setAttribute('download', this.filename)
      document.documentElement.appendChild(link)
      link.click()
      document.documentElement.removeChild(link)
    },
    handleProduction() {
      this.renovate()
      this.importVisible = false
    },
    async updateFn() {
      // 更新工单
      let ids = this.multipleSelection.map(v => v.id)
      let isSelectAll = 0
      if (this.multipleSelection.length < 1) isSelectAll = 1
      const res = await updateOrder(ids, isSelectAll)
      if (res.code != 0) {
        this.$message.warning({
          showClose: true,
          message: res.msg,
          duration: 0
        })
        return
      }
      if (res.data.hasLogs) {
        this.saleDialog = true
      } else if (!res.data.hasLogs) {
        this.$message.success('更新工单成功！')
      }
    },
    closeMerge() {
      this.isShow = false
    },
    async OKMerge() {
      this.isShow = false
      await this.renovate()
    },
    closeSplit() {
      this.isShowSplit = false
    },
    async splitOk() {
      this.isShowSplit = false
      await this.renovate()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      let arr = []
      let arrData = []
      val.forEach(v => {
        arr.push(v.id)
        arrData.push({
          num: v.orderNo,
          date: v.orderCompletionDateStr,
          id: v.id
        })
      })
      this.splitData = this.mergeData = arrData
    },
    async exportFn() {
      // 导出
      // if (this.multipleSelection.length < 1) {
      //   this.$message.warning('请选择需要导出的销售订单！')
      //   return
      // }
      // let ids = []  // 选中的销售订单id
      // for (let i = 0; i < this.multipleSelection.length; i++) {
      //   ids.push(this.multipleSelection[i].id)
      // }
      const res = await export2()
      this.filename = `销售订单 ${getDay()}.xlsx`
      this.url = window.URL.createObjectURL(res)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = this.url
      link.setAttribute('download', this.filename)
      document.documentElement.appendChild(link)
      link.click()
      document.documentElement.removeChild(link)
      this.$message.success('导出成功！')
    },
    split() {
      // 拆分
      if (this.multipleSelection.length < 1) {
        this.$message.warning({
          showClose: true,
          message: '请选择一个订单！',
          duration: 0
        })
        return
      }
      if (this.multipleSelection.length > 1) {
        this.$message.warning({
          showClose: true,
          message: '不能同时拆分多个订单！',
          duration: 0
        })
        return
      }
      this.isShowSplit = true
    },
    merge() {
      // 合并
      if (this.multipleSelection.length < 2) {
        this.$message.warning({
          showClose: true,
          message: '请至少选择两个订单号进行合并！',
          duration: 0
        })
        return
      }
      this.isShow = true
    },
    async yida() {
      // 钉钉导入
      // 注意这里最多一次导入100条
      const res = await importOrder2(1, 100)
      if (res.code === 0) {
        this.$message.success('钉钉导入成功！')
      } else {
        this.$message.error({
          showClose: true,
          message: res.msg,
          duration: 0
        })
      }
      await this.renovate()
    },
    // 分页组件--一页显示多少条数据
    async handleSizeChange(val) {
      this.pageChange = val
      if (this.status) {
        this.tempData = this.tempData2.filter((v, i) => i < val)
      } else if (this.searchStatus) {
        this.tempData = this.searchData.filter((v, i) => i < val)
      } else {
        const res = await getSaleData(1, val)
        const { records } = res.data
        this.tableData = records
        this.tempData = this.tableData
      }
      this.currentPage1 = 1
    },
    // 分页组件--选择页数
    async handleCurrentChange(val) {
      if (this.status) {
        // 如果数据经过筛选
        this.tempData = this.tempData2.slice(val * this.pageChange - this.pageChange, val * this.pageChange)
      } else if (this.searchStatus) {
        this.tempData = this.searchData.slice(val * this.pageChange - this.pageChange, val * this.pageChange)
      } else {
        const res = await getSaleData(val, this.pageChange)
        const { records } = res.data
        this.tableData = records
        this.tempData = records
      }
      this.currentPage1 = val
    },
    async searchHandler() {
      const res = await searchSaleData(1, this.tempTotal, this.input2)
      // 搜索后的总条数
      const { records } = res.data
      this.searchData = records
      this.searchStatus = true
      this.pageFn()
      this.tempData = this.searchData.filter((v, i) => i < 10)
      this.total = this.searchData.length
    },
    // 筛选状态
    async handleCommand(item) {
      const res = await getSaleData(1, this.tempTotal)
      const { records } = res.data
      this.status = true
      this.pageFn()
      if (item === 1) {
        this.tempData2 = records.filter(v => v.orderStatus === 1)
        this.tempData = this.tempData2.filter((v, i) => i < 10)
      } else if (item === 2) {
        this.tempData2 = records.filter(v => v.orderStatus === 2)
        this.tempData = this.tempData2.filter((v, i) => i < 10)
      }
      this.total = this.tempData2.length
    },
    async renovate() {
      // 刷新，重新赋值数据
      const res = await getSaleData(1, 10)
      const { records, total } = res.data
      this.tableData = records
      this.tempData = records
      this.total = total
      this.tempTotal = total
      this.pageFn()
      this.status = false
      this.searchStatus = false
      this.input2 = ''
    },
    pageFn() {
      this.pageChange = 10
      this.currentPage1 = 1
    },
    beforeAvatarUpload(file) {
      let fileArr = file.name.split('.')
      let suffix = fileArr[fileArr.length - 1]
      if (!/(xls|xlsx)/i.test(suffix)) {
        this.$message.warning({
          showClose: true,
          message: '文件格式不正确！',
          duration: 0
        })
        return false
      }
      if (file.size > 100 * 1024 * 1024) {
        this.$message.warning({
          showClose: true,
          message: '文件过大，请上传小于100MB的文件〜',
          duration: 0
        })
        return false
      }
      return true
    },
    uploadByJsqd(file) {
      if (this.beforeAvatarUpload(file)) {
        this.fileList.name = file.name
        this.fileName = file.name
        this.fileList.url = ''
        let formdata = new FormData()
        formdata.append('file', file.raw)
        importSale(formdata).then((res) => {
          if (res.code === 0) {
            this.resultVisible = true
            this.renovate()
          } else if (res.data !== 0) {
            this.resultVisible = true
            this.type = false
            this.resultMsg = res.msg
          }
        }, (err) => {
          console.log('当前打印err错误:', err)
        })
      }
    },
    closeFn() {
      this.resultVisible = false
    },
    reUpload() {
      let temp = document.querySelectorAll('.el-upload')
      temp[0].click()
    }
  },
  async created() {
    await this.renovate()
  }
}
</script>

<style lang="sass" scoped>
@import '../production/style/style.scss'
</style>